<template>
    <div class="biz-contract-comp">
        <modal class="alarm-orange" :display="modalStatus.signed" :isClose="false">
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
            <h1>簽約成功</h1>
            <div class="content">
                您的簽名完成了，我們已經通知您的房客確認合約，請您耐心等待
            </div>
            <div class="btn-group">
                <button class="default-button" @click="$router.push({name: 'bizBookingMgtDefault', hash: '#待租客簽約'})">回預定管理</button>
            </div>
        </modal>
        <modal class="alarm-orange" :display="modalStatus.econtract">
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
            <h1>成功儲存合約</h1>
            <div class="content">
                您可以繼續新增電子合約的流程
            </div>
            <div class="btn-group">
                <button class="default-button" @click="$router.push({name: 'bizNewEContract'})">回新增電子合約</button>
            </div>
        </modal>
        <modal class="alarm-orange" :display="modalStatus.renewal">
            <img class="alarm-img" src="@/assets/img/icon/alarm_msg_blue.svg" alt="">
            <h1>成功儲存合約</h1>
            <div class="content">
                您可以繼續續租的流程
            </div>
            <div class="btn-group">
                <button class="default-button" @click="$router.push({name: 'bizRenewalContract'})">回續租</button>
            </div>
        </modal>
        <div v-if="!status.isLoading" class="btn-group">
            <button v-if="this.$route.query.type==='release'" class="default-button" @click="setThrowLease">確認退租</button>
            <button v-else-if="(this.$route.query.type==='econtract' || this.$route.query.type==='renewal')&& this.$route.query.status==='view'" class="default-button" @click="$router.go(-1)">上一頁</button>
            <button v-else class="default-button" @click="saveContract" :disabled="!isSigned || status.isDisabled">確認</button>
        </div>
        <div class="contract-wrap" v-html="bizContract"></div>
        <html2image v-if="!status.isLoading" @toImage="appendAdComp"></html2image>
        <div v-if="status.isLoading" class="loading">
            <lottie-player src="../../../static/js/lf30_editor_TllSye.json"  background="transparent"  speed="1" color="#000"  style="width: 80px; height: 80px;"  loop autoplay></lottie-player>
        </div>
    </div>
</template>
<script>
import signBoard from '@/components/bussiness/mgtCategory/bookingMgt/bizContract/signBoard';
import html2image from '@/components/bussiness/mgtCategory/bookingMgt/bizContract/html2image';
import Modal from '@/components/widge/Modal.vue';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import Vue from 'vue'
import store from '@/store';
import { mapGetters } from 'vuex'
import { 
    apiBizContractThrowLease,
    apiGetUserIdCard,
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            testImg: null,
            // bizContract: null,
            modalStatus: {
                signed: false,
                econtract: false,
                renewal: false
            },
            status: {
                isLoading: true,
                isDisabled: false,
            }
        }
    },
    mounted () {
        this.$store.dispatch('setContractId', {contractCid: this.$route.query.contractCid, contractVersionId:  this.$route.query.contractVersionId})
        .then(()=>{
            setTimeout(()=>{
                this.status.isLoading = false
                this.appendSignComp()
            }, 6000)
        })
        document.documentElement.style.overflowY = 'hidden'; 
        // setTimeout(()=>{
        //     this.status.isLoading = true
        // }, 6000)
    },
    watch: {
        'status.isLoading': function (val) {
            if(!val){
                document.documentElement.style.overflowY = 'scroll'; 
            }
        },
    },
    methods: {
        saveContract: function () {
            this.status.isLoading = true
            this.status.isDisabled = true
            this.$store.dispatch('saveBizContractSign')
            .then( () => {
                this.status.isLoading = false
                this.status.isDisabled = false
                if(this.$route.query.type === 'econtract'){
                    this.$store.dispatch('bizSetNewEContractSingedStatus', true)
                    this.modalStatus.econtract = true
                }if(this.$route.query.type === 'renewal'){
                    this.$store.dispatch('bizSetRenewalContractSingedStatus', true)
                    this.modalStatus.renewal = true
                }else{
                    this.modalStatus.signed = true
                }
            })
        },
        setThrowLease: function () {
            let data = this.$route.query.contractCid
            apiBizContractThrowLease(data)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.$router.push({name: 'bizLeaseMgtDefault'})
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '已通知房客進行退租',type: 'success'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg, type: 'error'})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err, type: 'error'})
                console.log(err)
            })
        },
        appendSignComp: function () {
            console.log('appendSignComp')
            setTimeout(()=>{
                let ComponentClass = Vue.extend(signBoard)
                new ComponentClass({ 
                    el: ".current-sign-board",
                    store: store,
                });
            },500)
            
        },
        appendAdComp: function (val) {
            let element = document.getElementById('advertisement')
            let board = document.getElementsByClassName('sign-board')
            let img = document.createElement('img')
            img.src = val
            this.testImg = val
            console.log(board[0].children[1].style)
            board[0].children[1].style.alignItems = 'unset'
            board[0].children[1].style.justifyContent = 'unset'
            // board[0].children[1].style.border = 'none'
            
            element.appendChild(img)
            this.status.isLoading = false
            // let ComponentClass = Vue.extend(html2image)
            // new ComponentClass({ el: "#advertisement"});
        },
    },
    computed: {
        ...mapGetters({
            bizContract: 'GET_BIZ_CONTRACT',
            isSigned: 'IS_SIGNED',
            autoSign: 'GET_BIZ_USER_AUTO_SIGN',
        })
    },
    components: {
        signBoard,
        html2image,
        Modal,
        btnLoading
    }
}
</script>
<style lang="scss" scoped>
    .biz-contract-comp{
        #modal.alarm-orange{
            .modal-content{
                .cancle{
                    display: none;
                }
                .alarm-img{
                    width: 50px;
                    height: 50px;
                }
            }
        }
        >.btn-group{
            position: fixed;
            width: 848px;
            z-index: 2;
            text-align: right;
            left: 50%;
            transform: translateX(-424px);
            height: 90px;
            .default-button{
                position: relative;
                width: 120px;
                top: 24px;
                display: initial;
                align-items: unset;
                justify-content: unset;
            }
            .loading-wrap{
                position: relative;
                .btn-loading{
                    left: 64px;
                    top: 6px;
                }
            }
        }
        .contract-wrap{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .loading{
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            top: 0;
            z-index: 2;
        }
    }
    @media (max-width: 960px) {
        .biz-contract-comp{
            .btn-group{
                width: 100%;
                text-align: right;
                left: unset;
                transform: none;
                .default-button{
                    position: relative;
                    width: 100px;
                    height: 33px;
                    top: 8px;
                    right: 20px;
                    padding: 0px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/bookingMgt/bizContract/bizContract.vue